import React from "react";
import { Space } from "antd";
import {
  AxAccordion,
  AxButton,
  AxIconWrapper,
  AxDivider,
} from "@dynata/axiom3";

class Accordion extends React.Component {
  render() {
    return (
      <div className="section" id="accordion">
        <h3>Accodion</h3>
        <p>Renders a custom Axiom Accordion panels.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space size="large" direction="vertical">
          <div className="prop-header">
            <p className="props-title">Props: Accodion</p>
          </div>
          <table className="props-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Type</th>
                <th>Default</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>expandMultiple</td>
                <td>If true, Collapse renders as Accordion</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>activeKey</td>
                <td>Key of the active panel</td>
                <td>
                  string[] | string <br />
                  number[] | number
                </td>
                <td>
                  No default value. In <code>accordion</code> mode, it's the key
                  of the first panel
                </td>
                <td></td>
              </tr>
              <tr>
                <td>bordered</td>
                <td>
                  Toggles rendering of the border around the collapse block
                </td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>collapsible</td>
                <td>
                  Specify whether the panels of children be collapsible or the
                  trigger area of collapsible
                </td>
                <td>
                  <code>header</code> | <code>icon</code> |{" "}
                  <code>disabled</code>
                </td>
                <td>-</td>
                <td>4.9.0</td>
              </tr>
              <tr>
                <td>defaultActiveKey</td>
                <td>Key of the initial active panel</td>
                <td>
                  string[] | string <br />
                  number[] | number
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>destroyInactivePanel</td>
                <td>Destroy Inactive Panel</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>expandIcon</td>
                <td>Allow to customize collapse icon</td>
                <td>(panelProps) =&gt; ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>expandIconPosition</td>
                <td>Set expand icon position</td>
                <td>
                  <code>start</code> | <code>end</code>
                </td>
                <td>-</td>
                <td>4.21.0</td>
              </tr>
              <tr>
                <td>ghost</td>
                <td>
                  Make the collapse borderless and its background transparent
                </td>
                <td>boolean</td>
                <td>false</td>
                <td>4.4.0</td>
              </tr>
              <tr>
                <td>onChange</td>
                <td>Callback function executed when active panel is changed</td>
                <td>function</td>
                <td>-</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <div className="prop-header">
            <p className="props-title">Props: Accordion.Panel</p>
          </div>
          <table className="props-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Type</th>
                <th>Default</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>key</td>
                <td>Panel key</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>

              <tr>
                <td>title</td>
                <td>Title for Accordion panel</td>
                <td>reactNode</td>
                <td>-</td>
                <td></td>
              </tr>

              <tr>
                <td>subTitle</td>
                <td>Subtitle for Accordion panel</td>
                <td>reactNode</td>
                <td>-</td>
                <td></td>
              </tr>

              <tr>
                <td>status</td>
                <td>Wether to show status dot.</td>
                <td>
                  reactNode - <pre>{`<span className="dot"></span>`}</pre>
                </td>
                <td>-</td>
                <td></td>
              </tr>

              <tr>
                <td>callToAction</td>
                <td>To render CTA button in Accodion header</td>
                <td>
                  reactNode -{" "}
                  <pre>{`
<div>
  <AxButton
    color="neutral"
    type="secondary"
    size="medium"
    icononly={true}
  >
    <AxIconWrapper
      style={{ marginTop: "2px" }}
      type="regular"
      size="16"
      icon={"fa-arrow-right-to-bracket"}
    />
  </AxButton>
</div>`}</pre>
                </td>
                <td>-</td>
                <td></td>
              </tr>

              <tr>
                <td>footer</td>
                <td>To render footer with Accordion panel</td>
                <td>
                  reactNode -{" "}
                  <pre>{`
<div style={{ textAlign: "center", color: "#8c8c8c" }}>
  Footer Text
</div>`}</pre>
                </td>
                <td>-</td>
                <td></td>
              </tr>

              <tr>
                <td>collapsible</td>
                <td>
                  Specify whether the panel be collapsible or the trigger area
                  of collapsible
                </td>
                <td>
                  <code>header</code> | <code>icon</code> |{" "}
                  <code>disabled</code>
                </td>
                <td>-</td>
                <td>4.9.0 (icon: 4.24.0)</td>
              </tr>
              <tr>
                <td>extra</td>
                <td>The extra element in the corner</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>forceRender</td>
                <td>
                  Forced render of content on panel, instead of lazy rendering
                  after clicking on header
                </td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>header</td>
                <td>Title of the panel</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>key</td>
                <td>
                  Unique key identifying the panel from among its siblings
                </td>
                <td>string | number</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>showArrow</td>
                <td>
                  If false, panel will not show arrow icon. If false,
                  collapsible can't be set as icon
                </td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <pre>{`
 <AxAccordion defaultActiveKey={["1"]}>
 <AxAccordion.Panel
   key="1"
   title="Title Label"
   subTitle="Subtitle Label"
   status={<span className="dot"></span>}
   callToAction={
     <div>
       <AxButton
         color="neutral"
         type="secondary"
         size="medium"
         icononly={true}
       >
         <AxIconWrapper
           style={{ marginTop: "2px" }}
           type="regular"
           size="16"
           icon={"fa-arrow-right-to-bracket"}
         />
       </AxButton>
     </div>
   }
   footer={
     <div style={{ textAlign: "center", color: "#8c8c8c" }}>
       Footer Text
     </div>
   }
 >
   <p>Text here</p>
 </AxAccordion.Panel>
 <AxAccordion.Panel
   title="Title Label"
   subTitle="List Items Example"
   key="2"
   footer={
     <div style={{ textAlign: "center", color: "#8c8c8c" }}>
       Footer Text
     </div>
   }
 >
   <ul className="custom-list">
     <li>
       <span>
         <AxIconWrapper type="light" size="16" icon={"fa-circle-info"} />
         Row Label
       </span>
       <span>Detail</span>
     </li>
     <li>
       <span>
         <AxIconWrapper type="light" size="16" icon={"fa-circle-info"} />
         Row Label
       </span>
       <span>Detail</span>
     </li>
     <li>
       <span>
         <AxIconWrapper type="light" size="16" icon={"fa-circle-info"} />
         Row Label
       </span>
       <span>Detail</span>
     </li>
   </ul>
 </AxAccordion.Panel>
 <AxAccordion.Panel title="Title Label" key="3">
   <p>Text here</p>
 </AxAccordion.Panel>
</AxAccordion>       
          `}</pre>

          <div style={{ width: "400px" }}>
            <AxAccordion defaultActiveKey={["1"]}>
              <AxAccordion.Panel
                key="1"
                title="Title Label"
                subTitle="Subtitle Label"
                status={<span className="dot"></span>}
                callToAction={
                  <div>
                    <AxButton
                      color="neutral"
                      type="secondary"
                      size="medium"
                      icononly={true}
                    >
                      <AxIconWrapper
                        style={{ marginTop: "2px" }}
                        type="regular"
                        size="16"
                        icon={"fa-arrow-right-to-bracket"}
                      />
                    </AxButton>
                  </div>
                }
                footer={
                  <div style={{ textAlign: "center", color: "#8c8c8c" }}>
                    Footer Text
                  </div>
                }
              >
                <p>Text here</p>
              </AxAccordion.Panel>
              <AxAccordion.Panel
                title="Title Label"
                subTitle="List Items Example"
                key="2"
                footer={
                  <div style={{ textAlign: "center", color: "#8c8c8c" }}>
                    Footer Text
                  </div>
                }
              >
                <ul className="custom-list">
                  <li>
                    <span>
                      <AxIconWrapper
                        type="light"
                        size="16"
                        icon={"fa-circle-info"}
                      />
                      Row Label
                    </span>
                    <span>Detail</span>
                  </li>
                  <li>
                    <span>
                      <AxIconWrapper
                        type="light"
                        size="16"
                        icon={"fa-circle-info"}
                      />
                      Row Label
                    </span>
                    <span>Detail</span>
                  </li>
                  <li>
                    <span>
                      <AxIconWrapper
                        type="light"
                        size="16"
                        icon={"fa-circle-info"}
                      />
                      Row Label
                    </span>
                    <span>Detail</span>
                  </li>
                </ul>
              </AxAccordion.Panel>
              <AxAccordion.Panel title="Title Label" key="3">
                <p>Text here</p>
              </AxAccordion.Panel>
            </AxAccordion>
          </div>
        </Space>
      </div>
    );
  }
}
export default Accordion;
